import {Product} from '@shopify/hydrogen/storefront-api-types';
import {useQuery} from 'react-query';
import {queryApi} from '~/utils/queryAPI';

export function useBestSellers() {
  return useQuery(['fetch-best-sellers'], async () => {
    const res = await queryApi({
      url: '/api/bestSellers',
    });
    const data = (await res.json()) as Product[];
    return data || [];
  });
}
